  

export const itemStyle = (mouseIsOver, message) => {
  return {
    display: "grid",
    gridTemplateColumns: "10fr 1fr 1fr",
    gridTemplateRows: "auto",
    color: "white",
    fontSize: "14px",

    backgroundColor: message.selected
      ? mouseIsOver
        ? "#c8c6c4"
        : "#a19f9d"
      : mouseIsOver
      ? "#71afe5"
      : "#2b88d8",
    alignItems: "center",
    justifyContent: "right",
  };
};

export const columnStyle1 = () => {
  return {
    marginLeft: "20px",
  };
};
